import Vue from 'vue'
import Router from 'vue-router'

import home from '@/components/home'
import pricing from '@/components/pricing'
import photogallery from '@/components/photogallery'
import contacts from '@/components/contacts'
import accommodation from '@/components/accommodation'
import services from '@/components/services'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    }, 
    {
      path: '/cenik',
      name: 'pricing',
      component: pricing
    },
    {
      path: '/fotogalerie',
      name: 'photogallery',
      component: photogallery
    },
    {
      path: '/kontakty',
      name: 'contacts',
      component: contacts
    },
    {
      path: '/ubytovani',
      name: 'accommodation',
      component: accommodation
    },
    {
      path: '/sluzby',
      name: 'services',
      component: services
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
